import React from "react";
import { UpdateBadge } from "@ebscois/react-component-library";
import { SeparateLineUfoDiv, InlineUfoDiv } from "./_styled";

export default function ufoProcessor(options) {
  const updates = options.updates;
  const ufo = (node) => {
    const updateID = node?.attribs["update-id"];
    if (!updateID) {
      return null;
    }

    const update = updates?.find((i) => i.linkId === updateID);
    if (!update) {
      return null;
    }

    const updateType = update.badge?.updateType;

    if (
      updateType === "Topic Literature Review" ||
      updateType === "Algorithm"
    ) {
      return null;
    }

    if (!update?.badge?.isTimely) {
      return null;
    }

    const UpdatesBadge = (update) => {
      return (
        <UpdateBadge
          priority={update.badge.priority}
          showSubPriority={update.badge.healthEquity}
          text={update.badge?.updateType}
          timestamp={update.badge.timestamp}
        />
      );
    };

    if (updateType === "Evidence") {
      return (
        <SeparateLineUfoDiv data-testid="separate-line-ufo-div">
          {UpdatesBadge(update)}
        </SeparateLineUfoDiv>
      );
    }

    return (
      <InlineUfoDiv data-testid="inline-ufo-div">
        {UpdatesBadge(update)}
      </InlineUfoDiv>
    );
  };

  return { ufo };
}
